/**
 * Project: fuse-react-app
 * FilePath: /src/client/app/services/project.service.js
 * File: project.service.js
 * Created Date: Sunday, January 27th 2019, 7:18:07 pm
 * Author: Craig Bojko (craig.bojko@anexsys.com)
 * -----
 * Last Modified: Mon Feb 04 2019
 * Modified By: Craig Bojko
 * -----
 * Copyright (c) 2019 Anexsys
 * ------------------------------------
 */

import { rpc } from './lib/socketEngine.js'
import jwtService from 'modules/auth/jwtService'

export const SERVICE = 'PROJECTS'

export async function resolveProjects () {
  try {
    const token = jwtService.getAccessToken()
    if (!token) {
      throw new Error(`No JWT supplied to ${SERVICE} service`)
    }
    return await rpc('resolveProjects', {
      token
    })
  } catch (error) {
    throw new Error(error.message)
  }
}
